import { useContext } from 'react';
import { ClientPageEditContext } from '../ClientPageEditContext';

export default () => {
  const { edit: editable } = useContext(ClientPageEditContext);

  return { editable };
};
